import { render } from "./DeleteConfirmationDialog.vue?vue&type=template&id=8f9701a2&scoped=true"
import script from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js"

import "./dialog.scss?vue&type=style&index=0&id=8f9701a2&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f9701a2"]])

export default __exports__